module.exports = __webpack_public_path__ + "e0106718/img/splash-icon.07a7c465.svg";